import { render, staticRenderFns } from "./AppraisalScorecard.vue?vue&type=template&id=71a8dbd3"
import script from "./AppraisalScorecard.vue?vue&type=script&lang=js"
export * from "./AppraisalScorecard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports